import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FieldConfigChangedControllerService {
  private optionsChangeSubject = new BehaviorSubject<boolean>(false);
  optionsChanged$ = this.optionsChangeSubject.asObservable();
  private changedState = new Map();

  update(config: string, status: boolean): void {
    this.changedState.set(config, status);
    this.optionsChangeSubject.next(status);
  }

  get(config: string): boolean {
    return !!this.changedState.get(config);
  }

  clear(): void {
    this.changedState.clear();
    this.optionsChangeSubject.next(false);
  }
}
